import React from 'react';
import { PurchaseMethod } from '../model/interfaces';
import styles from '../styles/paymentOptionRadioButton.module.scss';

export default function PaymentOptionRadioButton(props: {
  value: PurchaseMethod;
  setValue: (val: PurchaseMethod) => void;
}) {
  return (
    <div className={styles.radio}>
      <input
        type="radio"
        name="opiton"
        value={props.value}
        id={props.value}
        onChange={(e) => props.setValue(e.target.value as PurchaseMethod)}
      />
      <label htmlFor={props.value}>{props.value}</label>
    </div>
  );
}
